import CommonSingleStepUploader from '../../Pages/BulkUploaders/CommonSingleStepUploader';

/**
 * TwoStepUploader component
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.steps - The title to be displayed in the uploader
 * @param {number} props.currentStep
 * @param {Object} props.firstProps
 * @param {Object} props.secondProps
 * @param {Function} props.onNext - Function to handle validation
 * @returns {JSX.Element} The rendered component
 */

// eslint-disable-next-line no-unused-vars
const TwoStepUploader = ({ title, steps, currentStep, firstProps, secondProps, onNext }) => {
  if (currentStep === 1) {
    return (
      <CommonSingleStepUploader
        key={firstProps.key}
        currentStep={currentStep}
        header={title}
        invoiceType={firstProps.invoiceType}
        onNext={firstProps.onNext}
        sampleEndpoint={firstProps.sampleEndpoint}
        selectionKey={firstProps.selectionKey}
        steps={steps}
        submitButtonText={firstProps?.submitButtonText}
        submitEndpoint={firstProps.submitEndpoint}
        title={firstProps.title}
        validationEndpoint={firstProps.validationEndpoint}
      />
    );
  }

  return (
    <CommonSingleStepUploader
      key={secondProps.key}
      currentStep={currentStep}
      header={title}
      invoiceType={secondProps.invoiceType}
      onNext={secondProps.onNext}
      sampleEndpoint={secondProps.sampleEndpoint}
      selectionKey={secondProps.selectionKey}
      steps={steps}
      submitEndpoint={secondProps.submitEndpoint}
      title={secondProps.title}
      validationEndpoint={secondProps.validationEndpoint}
    />
  );
};

export default TwoStepUploader;
